/* eslint-disable react/jsx-no-bind */

import React, {useState} from "react";
import PropTypes from "prop-types";
import Spinner from "../../../shared/components/Spinner";
import {TREND_ANSWERS} from "../constants";
import TrendImage from "./TrendImage";

const TrendImages = (props) => {
  const [
    finishedLoadingCount,
    setFinishedLoadingCount
  ] = useState(0);

  const {onAnswer, surveyFields} = props;
  const isStillLoading = () => TREND_ANSWERS.length < finishedLoadingCount;

  const onLoad = () => setFinishedLoadingCount(finishedLoadingCount + 1);

  return (
    <div>
      {isStillLoading() && <Spinner />}
      <div className={`trend-images ${isStillLoading() ? "invisible" : "visible"}`}>
        { TREND_ANSWERS.map(answer =>
          <div
            className="response"
            key={answer.prompt}
          >
            <TrendImage
              answer={answer}
              loadHandler={onLoad}
              onAnswer={onAnswer}
              surveyFields={surveyFields}
            />
          </div>)
        }
      </div>
    </div>
  );
};

TrendImages.propTypes = {
  "onAnswer": PropTypes.func.isRequired,
  "surveyFields": PropTypes.object.isRequired
};

export default TrendImages;
